import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { HeaderConfig } from '@core/models/header-config';
import { AuthService } from '@core/services/auth.service';
import { LayoutService } from '@core/services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { LANGUAGE_KEY } from 'src/app/app.module';

@Component({
    selector: 'app-layout-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  private readonly layoutService = inject(LayoutService);
  private readonly locationService = inject(Location);
  private readonly authService = inject(AuthService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly cookieService = inject(CookieService);
  private readonly router = inject(Router);
  private readonly formBuilder = inject(FormBuilder);
  private readonly translateService = inject(TranslateService);

  languageOptions: MenuItem[] = [
    {
      label: "COMMON.french",
      value: "fr",
    },
    {
      label: "COMMON.english",
      value: "en",
    }
  ];

  get cookieExpireDate(): Date {
    const _date = new Date();
    _date.setFullYear(_date.getFullYear() + 1);

    return _date;
  }

  get headerConfig(): HeaderConfig {
    return this.layoutService.headerConfig$();
  }

  get currentLang(): string {
    return this.cookieService.get(LANGUAGE_KEY) ? this.cookieService.get(LANGUAGE_KEY) : 'fr';
  }

  changeLanguage(lang: string): void {
    this.translateService.use(lang);
    this.cookieService.set(LANGUAGE_KEY, lang, { expires: this.cookieExpireDate });
  }

  goBack(): void {
    if (window.location.pathname === '/reset-password') {
      this.router.navigateByUrl("/login");
    } else if(window.location.pathname === '/login') {
      this.router.navigateByUrl("/");
    } else {
      this.locationService.back();
    }
  }

  doLogout(): void {
    this.authService.logout();
  }

  confirmLogout(): void {
    this.confirmationService.confirm({
      accept: () => this.doLogout()
    });
  }
}
